// extracted by mini-css-extract-plugin
export default {"Save":"style_Save__AAjB-","SaveActive":"style_SaveActive__9twzw"};